import { StoryType, STORY_TYPES } from '../../types/story';

interface StoryTypeSelectorProps {
  selectedType: StoryType | null;
  onSelectType: (type: StoryType) => void;
}

export default function StoryTypeSelector({
  selectedType,
  onSelectType,
}: StoryTypeSelectorProps) {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-display font-bold text-gray-900 mb-2">
          What's Your Story About?
        </h2>
        <p className="text-gray-600">
          Choose the situation your child is facing
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {STORY_TYPES.map((storyType) => (
          <button
            key={storyType.value}
            onClick={() => onSelectType(storyType.value)}
            className={`
              group relative p-6 rounded-2xl border-2 text-left transition-all duration-200
              ${
                selectedType === storyType.value
                  ? 'border-primary-500 bg-primary-50 shadow-soft-lg scale-105'
                  : 'border-gray-200 hover:border-primary-300 hover:shadow-soft'
              }
            `}
          >
            {/* Gradient overlay for selected */}
            {selectedType === storyType.value && (
              <div
                className={`absolute inset-0 bg-gradient-to-br ${storyType.color} opacity-5 rounded-2xl`}
              ></div>
            )}

            <div className="relative">
              {/* Emoji */}
              <div
                className={`
                text-5xl mb-3 transition-transform duration-200
                ${selectedType === storyType.value ? 'scale-110' : 'group-hover:scale-110'}
              `}
              >
                {storyType.emoji}
              </div>

              {/* Label */}
              <h3 className="text-lg font-display font-bold text-gray-900 mb-2">
                {storyType.label}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-600 leading-relaxed">
                {storyType.description}
              </p>

              {/* Selected indicator */}
              {selectedType === storyType.value && (
                <div className="absolute top-2 right-2">
                  <div className="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      {selectedType && (
        <div className="mt-6 p-4 bg-primary-50 border-2 border-primary-200 rounded-xl">
          <p className="text-sm text-primary-800">
            <span className="font-semibold">Selected:</span>{' '}
            {STORY_TYPES.find((t) => t.value === selectedType)?.label}
          </p>
        </div>
      )}
    </div>
  );
}
